<script lang="ts">
export let title;
export let subtitle;
export let link;
export let src;
export let islink;
</script>

<div id="root">
	<p id='t'>{title}</p>
	<p id='s'>{subtitle}</p>
	<div id='box'>
        {#if islink}
            <iframe class="frm" title="" src={src}
                    frameborder="0"
            		allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            		allowfullscreen/>
        {:else}
            <img class="img" src={src} alt=""/>
        {/if}
        <a href={link} target="_blank">site</a>
	</div>
</div>


<style type="text/scss">
$w: 560px;
$h: 315px;
#root {
    width: $w;
	@media (max-width: $w) { width: 100%; }
	#t {
		font-size: 18px;
		margin-bottom: 2px;
	}
	#s {
		font-size: 13px;
		margin-top: 0;
		width: $w;
		@media (max-width: $w) { width: 100%; }
    }
	#box {
		position: relative;
		a {
			font-size: 13px;
			width: 40px;
            height: 20px;
            line-height: 20px;
			text-align: center;
			position: absolute;
			top: -38px; 
			right: 1px;
			color: #fff;
			background-color: #000;
			border-radius: 2px;
            text-decoration: none;
			&:hover {
				background-color: #f00;
			}
		}
        .img {
			width: $w;
			@media (max-width: $w) { width: 100%; }
			border: 1px solid #e5e5e5; box-sizing: border-box;
		}
        .frm {
			width: $w;
			@media (max-width: $w) { width: 100%; }
			height: $h;
		}
	}
}
</style>